import { api, dynamic, registry } from './api';
import CacheStorage from './CacheStorage';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const updateCachedIncident = async (id, data, tab) => {
  const url = `${baseURL}/incident/${id}`;
  let incident = await cacheStorage.getFromCache(url);
  if (incident && incident.tabNotifications && data.id) {
    incident[tab] = data;
  } else {
    incident = data;
  }

  await cacheStorage.updateCache(incident, url);
};

const updateCachedIncidentList = async (data) => {
  const url = `${baseURL}/incident/?page=1&pageSize=10`;
  let items = await cacheStorage.getFromCache(url);

  if (items && items.itemList) {
    let element = items.itemList.find((el) => el.id == data.id);

    if (element == null) {
      items.itemList = items.itemList.concat([data]);
      items.rowCount = items.rowCount + 1;
    } else {
      items.itemList[items.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);
  }
};

const createCachedIncidentCAR = async (id, data) => {
  //creazione cache lista car pagina dedicata, alla creazione di un nuovo incident
  const url = `${baseURL}/incident/${id}/car/`;
  cacheStorage.updateCache(data, url);
};

const updateCachedIncidentCAR = async (id, data) => {
  //update lista car pagina dedicata
  const url = `${baseURL}/incident/${id}/car/?page=1&pageSize=10`;
  let items = await cacheStorage.getFromCache(url);

  if (items && items.incidentCAR) {
    let element = items.incidentCAR.itemList.find((el) => el.id == data.id);

    if (element == null) {
      items.incidentCAR.itemList = items.incidentCAR.itemList.concat([data]);
    } else {
      items.incidentCAR.itemList[items.incidentCAR.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);

    //update lista car in tabCauses dell'incident
    updateCachedTabCausesIncidentCAR(id, items.incidentCAR);
  }
};

const updateCachedTabCausesIncidentCAR = async (id, data) => {
  const url = `${baseURL}/incident/${id}`;
  let incident = await cacheStorage.getFromCache(url);
  if (incident && incident.tabCauses) {
    incident.tabCauses.incidentCAR = data.itemList;
    await cacheStorage.updateCache(incident, url);
  }
};

const createCachedIncidentCARDatail = async (idIncident, idCar, data) => {
  //creazione cache dettaglio car pagina dedicata
  const url = `${baseURL}/incident/${idIncident}/car/${idCar}`;
  const carDetail = {
    result: data,
    resultCas: {
      currentPage: 1,
      itemList: [],
      pageCount: 0,
      pageSize: 10,
      rowCount: 0,
    },
  };
  data = carDetail;
  await cacheStorage.updateCache(data, url);
};

const updateCachedIncidentCA = async (idIncident, idCar, data) => {
  //update pagina dettaglio car e lista ca
  const url = `${baseURL}/incident/${idIncident}/car/${idCar}`;

  let items = await cacheStorage.getFromCache(url);

  if (items && items.result.ca) {
    let element = items.result.ca.find((el) => el.id == data.id);

    if (element == null) {
      items.result.ca = items.result.ca.concat([data]);
      items.resultCas.itemList = items.resultCas.itemList.concat([data]);
    } else {
      items.result.ca[items.result.ca.indexOf(element)] = data;
      items.resultCas.itemList[items.resultCas.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);

    //update lista car
    updateCachedCAOnIncidentCARList(idIncident, idCar, items.ca);
  }
};

const updateCachedCAOnIncidentCARList = async (idIncident, idCar, data) => {
  const url = `${baseURL}/incident/${idIncident}/car/?page=1&pageSize=10`;
  let items = await cacheStorage.getFromCache(url);

  if (items && items.incidentCAR) {
    let element = items.incidentCAR.itemList.find((el) => el.id == idCar);
    if (element != null) {
      element.ca = data;
      //console.log({ 'updateCachedCAOnIncidentCARList': items, element });
      await cacheStorage.updateCache(items, url);
    }
  }
};
const updateReportFilter = async (data) => {
  const url = `${baseURL}/incident/filter`;
  await cacheStorage.updateCache(data, url);
};
const updateReport = async (data) => {
  const url = `${baseURL}/incident`;
  await cacheStorage.updateCache(data, url);
};
const getBackPaged = async () => {
  const url = `${baseURL}/incident/filter`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const fetchIncident = async () => {
  await api.getAll('/incident/?page=1&pageSize=10');
  await dynamic.getAll('country', { params: { page: 0 } });
  await dynamic.getAll('company', { params: { page: 0 } });
  await api.getAll('/registry/status?page=0');
  await api.getAll('/me/worksitesproject');

  await api.getAll('/activity');

  await dynamic.getAll('place', { params: { page: 0 } });
  await dynamic.getAll('probability', { params: { page: 0 } });
  await dynamic.getAll('severity', { params: { page: 0 } });
  await dynamic.getAll('lifesavingrule', { params: { page: 0 } });
  await dynamic.getAll('lifesavingrulecategory', { params: { page: 0 } });
  await dynamic.getAll('injurytype', { params: { page: 0 } });
  await dynamic.getAll('accidentsource', { params: { page: 0 } });
  await dynamic.getAll('measureunit', { params: { page: 0 } });
  await dynamic.getAll('contracttype', { params: { page: 0 } });
  await dynamic.getAll('shiftduration', { params: { page: 0 } });
  await dynamic.getAll('injurysource', { params: { page: 0 } });
  await dynamic.getAll('injuryclass', { params: { page: 0 } });
  await dynamic.getAll('bodypart', { params: { page: 0 } });
  await dynamic.getAll('directcause', { params: { page: 0 } });
  await dynamic.getAll('directcausedetail', { params: { page: 0 } });
  await dynamic.getAll('rootcause', { params: { page: 0 } });
  await dynamic.getAll('rootcausedetail', { params: { page: 0 } });
  await dynamic.getAll('rootcausesubdetail', { params: { page: 0 } });
  await dynamic.getAll('assetdamagetype', { params: { page: 0 } });

  await dynamic.getAll('workprocess', { params: { page: 0, parent: 'all' } });
  await dynamic.getAll('workarea', { params: { page: 0, parent: 'all' } });
  await dynamic.getAll('equipment', { params: { page: 0, parent: 'all' } });
  await dynamic.getAll('subcontractor', { params: { page: 0, parent: 'all' } });

  await registry.getAll('publicauthorities');
  await registry.getAll('transportaccident');
  await registry.getAll('workrelated');
  await registry.getAll('infooriginator');

  // foreach chiamate condizionali
  // dynamic.getAll('workprocess', { params: { page: 0 } })
  //   .then(response => {
  //     var data = response.data.itemList;
  //     data.map(item =>
  //       dynamic.getAll('workprocess', { params: { page: 0, parent: item.id, } })
  //     );
  //   }).catch(error => {

  //   }).finally(() => {

  //   });

  // dynamic.getAll('workarea', { params: { page: 0 } })
  //   .then(response => {
  //     var data = response.data.itemList;
  //     data.map(item =>
  //       dynamic.getAll('workarea', { params: { page: 0, parent: item.id, } })
  //     );
  //   }).catch(error => {

  //   }).finally(() => {

  //   });

  // dynamic.getAll('equipment', { params: { page: 0 } })
  //   .then(response => {
  //     var data = response.data.itemList;
  //     data.map(item =>
  //       dynamic.getAll('equipment', { params: { page: 0, parent: item.id, } })
  //     );
  //   }).catch(error => {

  //   }).finally(() => {

  //   });
  //fine foreach
};

const getBodyParts = async () => {
  const parts = await (await dynamic.getAll('bodypart')).data;
  console.log("Get body parts", parts);
  return parts;
}

const IncidentRepository = {
  updateCachedIncident,
  updateCachedIncidentList,
  createCachedIncidentCAR,
  updateCachedIncidentCAR,
  createCachedIncidentCARDatail,
  updateCachedIncidentCA,
  fetchIncident,
  updateReport,
  updateReportFilter,
  getBackPaged,
  getBodyParts,
};
export default IncidentRepository;
